var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "horizontal-bar" }, [
    _c("div", { staticClass: "horizontal-bar__wrap" }, [
      _c("div", { staticClass: "horizontal-bar__title" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ]),
      _c("div", { staticClass: "horizontal-bar__bar" }, [
        _c("div", {
          staticClass: "horizontal-bar__progress",
          style: _vm.progressStyle
        })
      ])
    ]),
    _c("div", { staticClass: "horizontal-bar__points" }, [
      _vm._v(_vm._s(_vm.value)),
      _c("span", [_vm._v("5")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }